module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAARBJREFUSInVVVtugzAQnKE5UI/gHoR8FvUUwCki9zMcJL5YNf3gIYxZwGmqpvOF19bszO5qAf47mES6i6Ne6lwiUQEAUFbtPF7E5L6milsuOQBQaCg06LwhrvM1r172gwOYOC5uDBXJo4XFLJRVCzDMS3waPyg6AGFPYa6I1MEGKLpByGGczJvO1wmZ8AoAvH5GgyAqWK5MBz25nHU/o990ZTvo0wSd39+m06B8LWYhqwf34NcT7JRILirBapPlAIbsBKICla6qFAzTHspJgLJqBUSjt9bkPfx1D2JsleIhCY7tIDkRzXiaSiR+tYDcT9f1MsTlA2rMbo+ejUH9zOnKL7NXkbs1gaEK5ccdwp4Z3ySScinjIRKZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/11.png
// module id = mTd6
// module chunks = 1